import { Injectable } from '@angular/core';
import { FilterFieldType, FilterFieldValue } from '../covance-filter';

@Injectable()
export class EQueryFilterDefinitions {
    public accessionNo(): FilterFieldValue {
        return {
            def : {
                title: 'Accession',
                queryParam: 'accessionNumber',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
                leaveOnlySelectedItems: true
            }
        };
    }

    public visitCollectionDate(): FilterFieldValue {
        return {
            def: {
                title: 'Collected Date',
                    queryParam: 'visitCollectionDate',
                    isServerSideFilter: true,
                    type: FilterFieldType.DateRange,
            }
        };
    }

    public visitName(): FilterFieldValue {
        return {
            def: {
                title: 'Visit',
                queryParam: 'visitName',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
            }
        };
    }

    public pVc(): FilterFieldValue {
        return {
            def: {
                title: 'PVC',
                    queryParam: 'visitCode',
                    isServerSideFilter: true,
                    type: FilterFieldType.MultiSelect,
            }
        };
    }

    public subject(): FilterFieldValue {
        return {
            def: {
                title: 'Subject',
                queryParam: 'subject',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
            }
        };
    }

    public eQueryId(): FilterFieldValue {
        return {
            def: {
                title: 'eQueryId',
                queryParam: 'eQueryId',
                isServerSideFilter: true,
                type: FilterFieldType.Number,
                width: 80
            }
        };
    }

    public age(): FilterFieldValue {
        return {
            def: {
                title: 'eQuery Age',
                queryParam: 'age',
                isServerSideFilter: true,
                isPinned: true,
                type: FilterFieldType.Age,
            }
        };
    }
    public site(): FilterFieldValue {
        return {
            def: {
                title: 'Site',
                queryParam: 'site',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
                leaveOnlySelectedItems: true,
                isPinned: true
            }
        };
    }

    public protocol(): FilterFieldValue {
        return {
            def: {
                title: 'Protocol',
                queryParam: 'protocol',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
                isPinned: true
            }
        };
    }

    public sponsor(): FilterFieldValue {
        return {
            def: {
                title: 'Sponsor',
                queryParam: 'sponsor',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
                isPinned: true
            }
        };
    }

    public projectNumber(): FilterFieldValue {
        return {
            def: {
                title: 'Project',
                queryParam: 'project',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
                leaveOnlySelectedItems: true,
            }
        };
    }

    public status(): FilterFieldValue {
        return  {
            def: {
                title: 'Status',
                queryParam: 'status',
                isServerSideFilter: true,
                type: FilterFieldType.MultiSelect,
                isPinned: true,
                skipMissingItems: true
            }
        };
    }
}
